import { useTranslation } from "react-i18next";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Every toast has an X: they sit over the header's account menu, so they must go away at once.
const Toaster = ({ ...props }: ToasterProps) => {
  const { t } = useTranslation();
  return (
    <Sonner
      className="toaster group"
      closeButton
      toastOptions={{
        closeButtonAriaLabel: t("common.close"),
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
